import React from "react";
import { Anchor } from "lucide-react";
import { defaultIconProps, IconProps, sizeMap } from "./types";

/**
 * One Piece TCG icon. Until Bandai's stylized "ONE PIECE" mark is added as
 * a proper SVG asset, we use a Lucide Anchor in One Piece red — the pirate
 * theme reads cleanly at icon sizes and is instantly recognizable.
 */
export const OnePieceIcon = ({
  size = defaultIconProps.size,
  color = defaultIconProps.color === "currentColor" ? "#E60012" : defaultIconProps.color,
  className = "",
  fontSize,
}: IconProps) => {
  const pixelSize = fontSize ?? sizeMap[size as keyof typeof sizeMap];
  return (
    <Anchor
      size={pixelSize}
      color={color}
      className={`inline-block ${className}`}
    />
  );
};
